import React from 'react'
import Header from '../component/Header/Header'
import ArticleContent from '../component/ArticleContent/ArticleContent'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import Footer from '../component/Footer/Footer'

const serviceData=[
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn more",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn more",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn more",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn more",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn more",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn more",
        btnRef:"/"
    },
    
]
function Articleinner() {
  return (
    <div>
        <Header/>

        <div className='upper-gradient'>

        <ArticleContent/>
        </div>

        <div className='bottom-gradient-simple'>
          <HomeProgram
            mainCardHeading="A Comprehensive Program Designed to Empower You"
            mainCardPara="At The Toronto Clinic, we champion a holistic approach to your well-being. Our program initiates with an exhaustive health assessment, spotlighting and mitigating potential risks from the onset. Our commitment ensures you not only feel your best but also thrive with vigor, confidence, and vitality."
            btnText="Explore membership"
            btnRef="/membership"
            serviceData={serviceData}
            mainCardImg={'/images/creatives/course-main-card-img.png'}
          backgroundPlain={true}
          />

          <Footer
          newsletterSection={false}
          />
          </div>
    </div>
  )
}

export default Articleinner